import React, { useState } from 'react';
import cl from './Search.module.css';
import Product from '../Products/Product/Product';
import Fuse from 'fuse.js';

const Search = (props) => {
  const [data, setData] = useState(props.productsPage.productsData);

  const options = {
    keys: ['name'],
  };

  const fuse = new Fuse(props.productsPage.productsData, options);
  const searchResult = fuse.search(props.productsPage.newSearchText);
  let searchResultsIds = searchResult.map((search) => search.refIndex);
  console.log(searchResult);
  const [isResultVisible, setIsResultVisible] = useState(cl.hidden_result);
  let featuredProducts = (p) => {
    // if (props.productsPage.productsData.indexOf(p)<6) {
    return (
      <Product onAdd={props.onAdd} productId={p.productId} name={p.name} images={p.images} oldPrice={p.oldPrice} currency={p.currency} discount={p.discount} path={'/products/' + p.path} />
    );
    // }
  };

  let productElements = searchResult.map((p) => featuredProducts(p.item));

  let seacrhText = props.productsPage.newSearchText;
  let onCliick = () => {
    console.log(seacrhText);
  };
  return (
    <section className={cl.search_container}>
      <h1 onClick={onCliick}>Risultati di ricerca</h1>
      <div className={cl.search_products}>{productElements}</div>
    </section>
  );
};

export default Search;
